export enum urlType {
  userProfile = 'userProfile',
  manageAccount = 'manageAccount',
  transactions = 'transactions',
  languagePreference = 'languagePreference',
  aboutUsWhoWeAre = 'aboutUsWhoWeAre',
  termsAndConditions = 'termsAndConditions',
  privacyPolicy = 'privacyPolicy',
  accessSupport = 'accessSupport',
  home = 'home',
  faq = 'faq',
  trackSupportTicket = 'trackSupportTicket'
}
